import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '@/axios';
import { responseHandler } from '@/utils';

interface SetUserPasswordParams {
  uid: string;
  newPassword: string;
  /** Token zaproszenia. Gdy brak → backend wymaga zalogowania i pozwala zmienić
   *  wyłącznie WŁASNE hasło (axiosInstance dokleja Bearer automatycznie). */
  token?: string;
}

// v3-setUserPassword to onRequest (POST), nie callable — stąd axios zamiast httpsCallable.
export const useSetUserPassword = () => useMutation({
  mutationFn: ({ uid, newPassword, token }: SetUserPasswordParams) => axiosInstance.post(
    '/v3-setUserPassword',
    { uid, newPassword, ...(token ? { token } : {}) },
    { headers: { 'Content-Type': 'application/json' } },
  ).then(responseHandler),
});
